export default __webpack_public_path__ + "static/media/logo.7af371fb.png";